// translations/en.ts
export default {
  login: 'Login',
  signup: 'Sign Up',
  forgotPassword: 'Forgot Password',
  email: 'Email',
  password: 'Password',
  confirmPassword: 'Confirm Password',
  name: 'Name',
  createDevAccount: 'Create DEV Account Automatically',
  autoDev: 'DEV Account (for quick tests)',
  welcomeBack: 'Welcome Back',
  noAccount: "Don't have an account?",
  haveAccount: 'Already have an account?',
  naoTemConta: "Don't have an account yet?",
  cadastrar: 'Create account',
  entrar: 'Sign In',
  esqueceuSenha: 'Forgot your password?',
  ouContinuarCom: 'Or continue with',
  entrarComGoogle: 'Sign in with Google',
  entrarComGithub: 'Sign in with GitHub',
  entrarComoDev: 'Sign in as developer',
  credenciaisInvalidas: 'Invalid email or password.',
  recuperarSenha: 'Recover password',
  enviarLinkRecuperacao: 'Send recovery link',
  voltarLogin: 'Back to login',
  linkRecuperacaoEnviado: 'Recovery link sent! Check your email.',
  emailInvalido: 'Enter a valid email',
  emailEnviado: 'Email sent successfully!',
  erroEnviarEmail: 'Could not send email. Please try again.',
  verifiqueSeuEmail: 'Check your email',
  senha: 'Password',

  sidebar: {
    dashboard: 'Dashboard',
    inbox: 'Inbox',
    demandas: 'Demands',
    projetos: 'Projects',
    kanban: 'Kanban',
    calendario: 'Calendar',
    gantt: 'Gantt',
    timeTracker: 'Time',
    aiStudio: 'AI Studio',
    notas: 'Notes',
    objetivos: 'Objectives',
    relatorios: 'Reports',
    equipe: 'Team',
    chatGlobal: 'Chat',
    chat: 'Chat',
    templates: 'Templates',
    configuracoes: 'Settings',
  },

  mobileMenu: {
    abrirMenu: 'Open menu',
    fecharMenu: 'Close menu',
  },

  novaDemanda: 'New Demand',

  search: 'Search demands, chats, notes...',
  notifications: 'Notifications',
  profile: 'Profile',
  newDemand: 'New Demand',

  dashboard: 'Dashboard',
  inbox: 'Unified Inbox',
  projetos: 'Projects',
  kanban: 'Kanban',
  demandas: 'Demands List',
  calendario: 'Calendar',
  gantt: 'Gantt',
  timeTracker: 'Time Tracker',
  aiStudio: 'AI Studio / Co-Pilot',
  notas: 'Notes',
  templates: 'Templates',
  objetivos: 'Objectives & OKRs',
  relatorios: 'Reports & Insights',
  equipe: 'Team & Permissions',
  chat: 'Global Chat',
  configuracoes: 'Settings',
  integracoes: 'Integrations',
  planos: 'Plans & Billing',
  ajuda: 'Help & AI Support',
  logout: 'Logout',

  meusDados: 'My Data',
  tema: 'Theme',
  idioma: 'Language',
  notificacoes: 'Notifications',
  salvar: 'Save Changes',
  atualizarFoto: 'Update Photo',
  alterarSenha: 'Change Password',

  light: 'Light',
  dark: 'Dark',
  system: 'System',
  gray: 'Gray',

  ptBR: 'Portuguese (Brazil)',
  en: 'English',
  atrasadas: 'Overdue',
  emProgresso: 'In Progress',
  concluidas: 'Completed',
  totalDemandas: 'Total Demands',
  sugerirIA: 'AI Suggestion',
  enviar: 'Send',
  notasDaDemanda: 'Notes',
  chatDaDemanda: 'Chat',
  detalhes: 'Details',
  atividade: 'Activity',
  anexos: 'Attachments',
  subtarefas: 'Subtasks',
  historico: 'Version History',
  prioridade: 'Priority',
  responsavel: 'Assignee',
  prazo: 'Due Date',
  tags: 'Tags',
  criar: 'Create',
  cancelar: 'Cancel',
  editar: 'Edit',
  excluir: 'Delete',
  sim: 'Yes',
  nao: 'No',
  carregando: 'Loading...',
  offline: 'Offline Mode - Data saved locally',
  sincronizando: 'Syncing when online...',
  status: 'Status',
  titulo: 'Title',
  todos: 'All',
  total: 'Total',
  progresso: 'Progress',
  pendente: 'Pending',
  concluido: 'Completed',
  atrasado: 'Overdue',
  arquivado: 'Archived',
  arquivar: 'Archive',
  aberta: 'Open',
  bloqueada: 'Blocked',
  emAndamento: 'In Progress',
  naoIniciado: 'Not Started',
  erro: 'Error',
  excluindo: 'Deleting...',
  salvando: 'Saving...',
  campoObrigatorio: 'Required field',
  dataInvalida: 'Invalid date',
  progressoInvalido: 'Invalid progress',
  confirmarExclusao: 'Confirm deletion',
  temCertezaQueDesejaExcluir: 'Are you sure you want to delete?',
  demandasRecentes: 'Recent Demands',
  proximosPrazos: 'Upcoming Deadlines',
  progressoDemandas: 'Demand Progress',
  progressoMedio: 'Average Progress',
  visaoGeralStatuses: 'Status Overview',
  ultimasDemandasCriadas: 'Latest Created Demands',
  nenhumaDemandaRecente: 'No recent demands',
  nenhumPrazoProximo: 'No upcoming deadlines',
  concluidasEstaSemana: 'Completed this week',
  vencemEmBreve: 'Due soon',
  totalDemandasDesc: 'Total registered demands',
  atrasadasDesc: 'Demands with expired deadline',
  emProgressoDesc: 'Demands in progress',
  concluidasDesc: 'Completed demands',
  bloqueadas: 'Blocked',
  bloqueadasDesc: 'Blocked demands',
  bemVindoMensagem: 'Welcome to Havk',
  buscarPorTituloDescricaoOuTag: 'Search by title, description or tag...',
  diaRestante: 'day remaining',
  diasRestantes: 'days remaining',
  evolucaoStatus: 'Status Evolution',
  evolucaoPorStatus: 'Status Evolution',
  acompanhamentoDeMetasDaEquipeEDashboardInterativo: 'Team goals tracking and interactive dashboard',

  perfilAtualizado: 'Profile updated successfully!',
  cliqueParaAlterarFoto: 'Click the camera to choose photo from gallery',
  salvarAlteracoes: 'Save Changes',
  permissoesSeguranca: 'Permissions & Security',

  /* TIME TRACKER */
  timeTrackerTitle: 'Time Tracker',
  timeTrackerDescription: 'Manage and track the time spent on your tasks',
  taskNamePlaceholder: 'Current task name...',
  start: 'Start',
  pause: 'Pause',
  stop: 'Finish',
  reset: 'Reset',
  activeSession: 'Active session running',
  sessionHistory: 'Session History',
  clearHistory: 'Clear history',
  statistics: 'Statistics',
  totalTrackedTime: 'Total tracked time',
  totalSessions: 'Total sessions',
  nenhumaSessaoAinda: 'No sessions recorded yet',
  sessaoRegistrada: 'Session recorded successfully',
  sessaoExcluida: 'Session deleted',
  historicoLimpo: 'History cleared',
  confirmarLimparHistorico: 'Are you sure you want to clear the history?',
  timerResetado: 'Timer reset',
  timePerTask: 'Time per task',
  digiteNomeTarefa: 'Current task name...',

  /* RELATÓRIOS */
  analiseDesempenho: 'Performance and productivity analysis',
  ultimos30Dias: 'Last 30 days',
  ultimos90Dias: 'Last 90 days',
  esteAno: 'This year',
  todoHistorico: 'All history',
  demandasConcluidas: 'Completed Demands',
  taxaConclusao: 'Completion Rate',
  mediaTempo: 'Average Completion Time',
  dias: 'days',
  evolucaoConclusoes: 'Completion Evolution',
  ultimosMeses: 'Last months',
  nenhumDadoPeriodo: 'No data in the selected period',
  distribuicaoStatus: 'Status Distribution',
  situacaoAtualDemandas: 'Current status of demands',
  topPerformers: 'Top Performers',
  responsaveisMaisConclusoes: 'Assignees with most completions',
  nenhumDadoDisponivel: 'No data available',
  mesAno: 'Month/Year',
  csvExportado: 'CSV exported successfully!',
  gerandoPDF: 'Generating PDF (may take a few seconds)...',
  pdfGerado: 'PDF generated and downloaded!',
  areaRelatorioNaoEncontrada: 'Report area not found',
  erroGerarPDF: 'Error generating PDF. Check the console and try again.',
  tentarNovamente: 'Try again',
  erroCarregar: 'Error loading',
  exportarRelatorio: 'Export Report',
  seguranca: 'Security',
  proprietario: 'Owner',

  /* TEMPLATES */
  modelosProntos: 'Ready-made models for demands, meetings, reports and more',
  gerarComIA: 'Generate with AI',
  gerando: 'Generating...',
  novoTemplate: 'New Template',
  buscarTemplate: 'Search by name, description or content...',
  maisRecentes: 'Most recent',
  aZ: 'A → Z',
  favoritosPrimeiro: 'Favorites first',
  nenhumTemplateEncontrado: 'No template found',
  semTemplatesAinda: 'You don’t have templates yet',
  ajusteFiltros: 'Try adjusting filters or clearing the search',
  crieTemplatesReutilizaveis: 'Create reusable templates to speed up your work',
  criarPrimeiroTemplate: 'Create First Template',
  criarNovoTemplate: 'Create new template',
  templateGeradoIA: 'AI Generated Template',
  iaGerado: 'AI Generated',
  templateCriadoIA: 'Template created automatically with AI assistance',
  conteudoTemplateIA: '# Demand Title\n\n## Objective\n\n## Steps / Requirements\n- Item 1\n- Item 2\n\n## Acceptance Criteria\n- Criterion 1\n- Criterion 2\n\n## Notes / Risks\n\n## Estimated Deadline\n\n## Assignee',
  removidoFavoritos: 'Removed from favorites',
  adicionadoFavoritos: 'Added to favorites',
  erroFavorito: 'Error updating favorite',
  confirmarExcluirTemplate: 'Are you sure you want to delete this template?',
  templateExcluido: 'Template deleted successfully.',
  erroExcluirTemplate: 'Error deleting template',
  templateDuplicado: 'Template duplicated!',
  erroDuplicarTemplate: 'Error duplicating template',
  semConteudoTemplate: 'This template has no content to copy.',
  conteudoCopiado: 'Content copied to clipboard!',
  editarTemplate: 'Edit Template',
  nomeObrigatorio: 'Name is required',
  categoriaObrigatoria: 'Category is required',
  descricaoObrigatoria: 'Description is required',
  conteudoObrigatorio: 'Template content is required',
  preenchaCamposObrigatorios: 'Fill in all required fields.',
  templateAtualizado: 'Template updated!',
  templateCriado: 'Template created successfully!',
  erroSalvarTemplate: 'Error saving template',
  salvarTemplate: 'Save Template',
  exReuniaoSprint: 'Ex: Sprint Planning Meeting',
  categoria: 'Category',
  exReunioesBugsFeatures: 'Ex: Meetings, Bugs, Features...',
  descricao: 'Description',
  breveDescricaoTemplate: 'Brief description of the purpose and usage of this template...',
  conteudoTemplate: 'Template Content',
  escrevaConteudoTemplate: 'Write here the content that will be copied when using the template...\n\nSupports Markdown, lists, tables, etc.',
  nome: 'Name',

  // NOTES
  minhasNotas: 'My Notes',
  novaNota: 'New Note',
  editarNota: 'Edit Note',
  tituloDaNota: 'Note title',
  escrevaSuaNotaAqui: 'Write your note here...',
  selecioneOuCrieNota: 'Select or create a note',
  preenchaTituloOuConteudo: 'Fill in the title or content',
  notaCriada: 'Note created successfully',
  notaAtualizada: 'Note updated successfully',
  erroSalvarNota: 'Error saving note',

  // OBJECTIVES
  objetivosEResultados: 'Objectives & Results',
  novoObjetivo: 'New Objective',
  criarObjetivo: 'Create Objective',
  editarObjetivo: 'Edit Objective',
  detalhesDoObjetivo: 'Objective Details',
  nenhumObjetivoEncontrado: 'No objective found',
  crieSeuPrimeiroObjetivoOuAjusteFiltros: 'Create your first objective or adjust filters',
  exAumentarProdutividade: 'Ex: Increase productivity by 20%',

  'gantt.title': 'Gantt Chart',

  paginaNaoEncontrada: 'Page not found',
  paginaNaoEncontradaDesc: 'The page you are looking for does not exist or has been moved.',
  voltarDashboard: 'Back to Dashboard',
  novaDemandaBtn: 'New Demand',

  /* CONFIGURAÇÕES */
  informacoesPessoais: 'Personal Information',
  fotoPerfil: 'Profile Photo',
  alterarFotoPerfil: 'Change Profile Photo',
  nomeCompleto: 'Full Name',
  digiteSeuNomeCompleto: 'Enter your full name',
  seuNome: 'Your Name',
  emailNaoPodeSerAlteradoAinda: 'Email cannot be changed yet',
  seuEmailPrincipal: 'Your main email',
  membroDesde: 'Member since',
  aparenciaDaAplicacao: 'Application Appearance',
  claro: 'Light',
  escuro: 'Dark',
  seguirSistema: 'Follow System',
  cinza: 'Gray Neutral',
  idiomaDaInterface: 'Interface Language',
  portugueseBrazil: 'Portuguese (Brazil)',
  englishUnitedStates: 'English (United States)',
  preferenciasDeNotificacoes: 'Notification Preferences',
  novasDemandas: 'New Demands',
  receberQuandoNovaDemandaCriada: 'Receive when a new demand is created',
  mensagensChat: 'Chat Messages',
  notificacoesNovasMensagens: 'Notifications for new messages',
  prazosProximos: 'Upcoming Deadlines',
  lembretesDePrazos: 'Deadline reminders',
  atualizacoesSistema: 'System Updates',
  novidadesEHavk: 'News and Havk updates',
  segurancaDaConta: 'Account Security',
  senhaAtual: 'Current Password',
  novaSenha: 'New Password',
  confirmarNovaSenha: 'Confirm New Password',
  atualizarSenha: 'Update Password',
  autenticacaoDoisFatores: 'Two-Factor Authentication',
  '2faAumentaSeguranca': '2FA increases account security',
  ativar2FA: 'Enable 2FA',
  emBreve: '(coming soon)',
  exportarMeusDados: 'Export My Data',
  excluirConta: 'Delete Account',
  sair: 'Log Out',
  confirmarLogout: 'Are you sure you want to log out?',
  simSair: 'Yes, log out',
  confirmeExclusaoConta: 'Confirm account deletion (irreversible action)',
  contaExcluida: 'Account deleted (simulated)',
  arquivoMuitoGrande: 'File exceeds 5MB',
  fotoAtualizada: 'Profile photo updated',
  perfilSalvo: 'Profile saved successfully',
  erroSalvar: 'Error saving profile',
  preenchaTodosCamposSenha: 'Fill in all password fields',
  senhasNaoCoincidem: 'Passwords do not match',
  senhaMin8Caracteres: 'New password must be at least 8 characters',
  senhaAlterada: 'Password changed successfully',
  dadosExportados: 'Data exported successfully',

  /* FOOTER */
  footer: {
    copyright: '© {{year}} Havk. All rights reserved.',
    terms: 'Terms',
    privacy: 'Privacy',
    help: 'Help',
  },
};